import _ from 'underscore'

import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'
import { replace } from 'helpers/formatters'

type Props = {
  legendNames: Array<string>
}

const Legend = ({ legendNames }: Props) => {
  return (
    <S.Legend>
      {
        _.unique(legendNames).map((name) => {
          return (
            <S.LegendItem key={name.replace(' ', '_')}>
              <S.LegendItemColorBox backgroundColor={name} />
              <S.LegendItemName>{name}</S.LegendItemName>
            </S.LegendItem>
          )
        })
      }
    </S.Legend>
  )
}

export default Legend

const S = {
  Legend: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 10px;
  `,
  LegendItem: styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-right: 10px;
  `,
  LegendItemColorBox: styled.div.withConfig({
    shouldForwardProp: (prop) => !['backgroundColor'].includes(prop)
  })<{ backgroundColor: string }>`
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    background: ${({ backgroundColor }) => color(replace(`premiumAdoption${backgroundColor}`, ' ', ''))};
    border: 1px solid ${color('border')};
  `,
  LegendItemName: styled.span`
    font-weight: bold;
    color: ${color('primaryText')};
  `
}
